type KioskKeypadProps = {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  maxLength?: number;
};

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "clear", "0", "back"] as const;

export function KioskKeypad({ value, onChange, disabled, maxLength = 15 }: KioskKeypadProps) {
  function press(key: (typeof KEYS)[number]) {
    if (disabled) return;
    if (key === "clear") {
      onChange("");
      return;
    }
    if (key === "back") {
      onChange(value.slice(0, -1));
      return;
    }
    if (value.length >= maxLength) return;
    onChange(value + key);
  }

  return (
    <div className="kiosk-keypad" role="group" aria-label="Phone keypad">
      {KEYS.map((key) => {
        const label = key === "clear" ? "Clear" : key === "back" ? "⌫" : key;
        const className =
          key === "clear" || key === "back"
            ? "kiosk-keypad-key kiosk-keypad-key--action"
            : "kiosk-keypad-key";
        return (
          <button
            key={key}
            type="button"
            className={className}
            onClick={() => press(key)}
            disabled={disabled}
            aria-label={key === "back" ? "Backspace" : key === "clear" ? "Clear" : key}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
